import { getLoggedInUserWithProfile } from '@/lib/collections/User/getMyInfoProfile';
import MyProfile from '@/user/myProfile';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/myProfile')({
    loader: async () => {
        const user = await getLoggedInUserWithProfile();
        return user;
    },
    component: ProfilePage,
});

function ProfilePage() {
    const user = Route.useLoaderData();
    return <MyProfile user={user} />;
}